module.exports = __webpack_public_path__ + "img/02.9fc56f8e.jpg";